var obj = {
    routers: [],
    set: function (res) {
        this.routers = res;
    },
    getAll: function () {
        return this.routers;
    },
    getByName: function (name)
    {
        return this.routers.filter(x => x.name === name);
    },
    getByCode: function (code)
    {
        return this.routers.filter(x => x.code === code);
    },
    getById: function (id)
    {
        return this.routers.find(x => x.id === id);
    },
    getByParentId: function (parentId)
    {
        return this.routers.filter(x => x.parentId === parentId);
    },
    getChildByCode: function (code) {
        var router = this.routers.find(x => x.code == code);
        return this.routers.filter(x => x.parentId == router.id);
    },
    getChildByName: function (name) {
        var router = this.routers.find(x => x.name == name);
        return this.routers.filter(x => x.parentId == router.id);
    }
};

export default {
    Router: obj
}